module.exports = __webpack_public_path__ + "img/bianzu_tr.501d1c09.png";